export default "__VITE_ASSET__9b7e3ffc__"